<template>
  <w-modal
    v-model="show"
    close-button="Anuluj"
    submit-button="Zapisz"
    :title="title"
    :close-on-submit="false"
    :hide-on-overlay="false"
    :hide-on-esc="false"
    @submit="save"
    @close="close"
  >
    <div class="row">
      <div class="form-group col-12">
        <w-vue-select
          v-if="useNameSelect"
          label-field="name"
          value-field="name"
          :model="$schema"
          :values="contests"
          :ajax="true"
          :taggable="true"
          @search="findContests"
        />

        <w-input v-else :model="$schema.name" />
      </div>

      <div class="form-group col-12">
        <w-input :model="$schema.declination.miejscownik" />
      </div>

      <div class="form-group col-12">
        <w-input :model="$schema.declination.dopelniacz" />
      </div>

      <div v-if="!hideSelects">
        <div class="form-group col-12">
          <w-select :model="$schema.type" :values="contestTypeList" />
        </div>

        <div class="form-group col-12">
          <w-select :model="$schema.level" :values="schoolLevelList" />
        </div>
      </div>
    </div>
  </w-modal>
</template>

<script>
import { mapState } from 'vuex';

import { ActionList } from '@/enums/action.enum';
import { contestTypeList } from '@/enums/contestType.enum';
import { Errors } from '@/enums/errors.enum';
import { EventTypeList } from '@/enums/eventType.enum';
import { schoolLevelList } from '@/enums/schoolLevel.enum';
import { manageMixin } from '@/mixins/manage';
import schema from '@/schemas/contest.schema';

const emptyData = () => ({ name: null, type: null, level: null, declination: { miejscownik: null, dopelniacz: null } });

// @vuese
// Modal dodania konkursu
// @group contest
export default {
  mixins: [manageMixin('contest', {}, emptyData)],
  props: {
    // Ukrywa selecty z wyborem typu i poziomu konkursu
    hideSelects: { type: Boolean, default: false },
    // Używa v-selecta szukającego w konkursach, zamiast normalnego inputa
    useNameSelect: { type: Boolean, default: false }
  },
  schema,
  data() {
    return { model: {}, contestTypeList, schoolLevelList, contests: [] };
  },
  computed: {
    title() {
      return this.id ? 'Edycja konkursu' : 'Dodawanie konkursu';
    }
  },
  methods: {
    // @vuese
    // Ustawia dane formularza
    setData() {
      if (Object.values(this.stateData).some(value => value ?? false)) {
        const model = this.stateData;
        model.declination = { ...emptyData().declination, ...model.declination };
        this.$schema.$setData(model);
      } else {
        this.$schema.$setData(emptyModel());
      }
      this.$schema.$reset();
    },
    // @vuese
    // Szuka konkursów
    findContests(search) {
      this.$store
        .dispatch('contest/list', { search })
        .then(contests => (this.contests = contests.list))
        .catch(err => this.notifyError(Errors.CONTEST_CANNOT_LIST));
    }
  }
};
</script>
